import * as React from "react";
function SvgPlusSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M20.571 9.857h-6.428V3.43c0-.79-.64-1.429-1.429-1.429h-1.428c-.79 0-1.429.64-1.429 1.429v6.428H3.43c-.79 0-1.429.64-1.429 1.429v1.428c0 .79.64 1.429 1.429 1.429h6.428v6.428c0 .79.64 1.429 1.429 1.429h1.428c.79 0 1.429-.64 1.429-1.429v-6.428h6.428c.79 0 1.429-.64 1.429-1.429v-1.428c0-.79-.64-1.429-1.429-1.429z"
        fill="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPlusSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
